import React, { useState, useMemo, useCallback, memo } from "react";
import "rc-slider/assets/index.css";
import { Range } from "rc-slider";
import moment from "moment";
import styled, { withTheme } from "styled-components";
import debounce from "lodash/debounce";
import { CheckBox, CheckBoxOutlineBlank } from "@material-ui/icons";

const FlexHolder = styled.div`
  display: flex;
  align-items: center;
  position: relative;
`;

const FlexHolderCursorPointer = styled(FlexHolder)`
  cursor: pointer;
`;

const StyledCheckbox = styled(CheckBox)`
  font-size: 16px !important;
  margin-right: 5px;
`;
const StyledOutlinedCheckbox = styled(CheckBoxOutlineBlank)`
  font-size: 16px !important;
  margin-right: 5px;
`;
const SliderWrapper = styled.div`
  bottom: 0px;
  left: 0px;
  background: #fff;
  width: 100%;
  height: 80px;
`;

const DAY_IN_SECONDS = 86400;

function getStartDayForEvent() {
  const hasValue =
    localStorage.getItem("last_usage") && localStorage.getItem("last_usage") !== "null";
  const last_usage = hasValue ? localStorage.getItem("last_usage") : null;
  if (last_usage) {
    return new Date(last_usage).getTime() / 1000;
  }
  const date = new Date();
  date.setDate(date.getDate() - 2);
  return date.getTime() / 1000;
}

function DateRange({ today, dateRange, setDateRange, theme }) {
  const [onlyNewEvents, setOnlyNewEvents] = useState(null);
  const dotStyles = {
    backgroundColor: theme.primaryColor,
    borderRadius: "25%",
    borderColor: theme.borderColor,
    boxShadow: "none",
  };

  const minDate = useMemo(
    () =>
      parseInt(
        moment(today)
          .subtract(6, "month")
          .format("X")
      ),
    [today]
  );

  const maxDate = useMemo(
    () =>
      parseInt(
        moment(today)
          .add(6, "month")
          .format("X")
      ),
    [today]
  );

  const [initialRange] = useState(dateRange);
  const [startDate, setStartDate] = useState(
    dateRange.startDate < minDate ? minDate : dateRange.startDate
  );
  const [endDate, setEndDate] = useState(dateRange.endDate);

  const onSliderChange = useCallback(
    value => {
      setStartDate(value[0]);
      setEndDate(value[1]);
    },
    [setStartDate, setEndDate]
  );

  const queryEvents = debounce(value => {
    setDateRange({ startDate: value[0], endDate: value[1] });
  }, 1000);

  return (
    <SliderWrapper>
      <Range
        value={[startDate, endDate]}
        defaultValue={[parseInt(startDate), parseInt(endDate)]}
        min={minDate}
        max={maxDate}
        disabled={onlyNewEvents}
        onChange={v => {
          onSliderChange(v);
        }}
        onAfterChange={v => queryEvents(v)}
        step={DAY_IN_SECONDS}
        allowCross={false}
        style={{ margin: "0 auto", width: "90%", marginTop: "15px" }}
        trackStyle={[{ backgroundColor: theme.borderColor }]}
        handleStyle={[dotStyles, dotStyles]}
        railStyle={{ backgroundColor: "#e1e1e1" }}
      />
      <p style={{ textAlign: "center", margin: 5 }}>
        <b>{moment.unix(startDate).format("Do MMMM  YYYY")}</b> bis{" "}
        <b>{moment.unix(endDate).format("Do MMMM  YYYY")}</b>
        <br />
        <div style={{ display: "flex", justifyContent: "center" }}>
          <FlexHolderCursorPointer
            alt="nur Updates anzeigen"
            title="nur Updates anzeigen"
            onClick={() => {
              if (!onlyNewEvents) {
                const values = [getStartDayForEvent(), new Date().getTime() / 1000];
                queryEvents(values);
                onSliderChange(values);
              } else {
                queryEvents([initialRange.startDate, initialRange.endDate]);
                onSliderChange([initialRange.startDate, initialRange.endDate]);
              }
              setOnlyNewEvents(!onlyNewEvents);
            }}
          >
            {onlyNewEvents ? <StyledCheckbox /> : <StyledOutlinedCheckbox />}
            <span>Nur Updates anzeigen</span>
          </FlexHolderCursorPointer>
        </div>
      </p>
    </SliderWrapper>
  );
}

export default withTheme(memo(DateRange));
